<template>
  <div></div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    export default {
        name: "MsgSucesso",
        computed: {
            ...mapGetters("msgSucesso", ['getMsgSucesso', 'getTxtMsgSucesso'])
        },
        data () {
            return {         
            } 
        },
        watch: {
            getMsgSucesso: function(val) {
                if (val) {
                    this.mensagem();
                    this.reiniciar();
                }
            }
        },
        methods: {
            ...mapActions('msgSucesso', {exibirMsgSucesso:'exibirMsgSucesso', reiniciar: 'reiniciar'}),
            mensagem() {
                this.$swal("Sucesso", this.getTxtMsgSucesso, "success");
            }
        }
}
</script>


// WEBPACK FOOTER //
// src/components/MsgSucesso.vue